<template>
  <div class="cvs-wrapper">
    <!-- company-profile display -->
    <div class="company-profile-container" v-animate-css="'fadeIn'">
      <multipane class="custom-resizer" layout="vertical">
        <!-- List of cv -->
        <div class="company-profile-body">
          <div class="search-widget">
            <div class="search-widget">
              <img src="@/assets/icons/search.svg" alt />
              <input type="text" placeholder="Search for templates here..." />
            </div>
          </div>

          <div class="cvs-item-header">
            <label class="title" v-if="section_type == 'all-cv'"
              >All CV templates</label
            >
            <label class="title" v-if="section_type == 'my-cv'">My CVs</label>
            <div class="options">
              <button class="add-btn" @click="show_add_cv_modal = true">
                + Add Template
              </button>
            </div>
          </div>

          <!-- Default cv -->
          <div class="cvs-body">
            <div class="cvs-item-header" v-if="section_type == 'all-cv'">
              <label>Default CV templates</label>
            </div>
            <div
              class="cvs-items"
              style="margin-bottom: 40px"
              v-if="section_type == 'all-cv'"
            >
              <div
                class="cv-item"
                v-for="(item, index) in default_template"
                :key="index"
              >
                <div class="cv-item-header">
                  <label>{{ item.name }}</label>
                  <dropdown-menu>
                    <ul>
                      <li>
                        <a href @click.prevent="download('default', item.n)"
                          >Download</a
                        >
                      </li>
                      <li>
                        <a href @click.prevent="appyTemp('default', item.n)"
                          >Apply</a
                        >
                      </li>
                    </ul>
                  </dropdown-menu>
                </div>
                <div
                  class="cv-item-body"
                  @click="selectTemp(item, 'default', item.n)"
                >
                  <img
                    :src="
                      require('@/assets/images/temp_docs/new/' +
                        item.n +
                        '.svg')
                    "
                  />
                </div>
              </div>
            </div>

            <!-- Customs CV templates -->
            <div
              class="cvs-item-header"
              v-if="cvs_data.length > 0 && section_type == 'all-cv'"
            >
              <label>Custom CV templates</label>
            </div>
            <div
              class="cvs-items"
              v-if="cvs_data.length > 0 && section_type == 'all-cv'"
            >
              <div
                class="cv-item"
                v-for="(item, index) in cvs_data"
                :key="index"
              >
                <div class="cv-item-header">
                  <label>{{ item.alias | validate }}</label>
                  <dropdown-menu>
                    <ul>
                      <li>
                        <a href @click.prevent="download('custom', item.name)"
                          >Download</a
                        >
                      </li>
                      <li>
                        <a href @click.prevent="appyTemp('custom', item.id)"
                          >Apply</a
                        >
                      </li>
                      <li>
                        <a href @click.prevent="removeTemp(item.id)">Remove</a>
                      </li>
                    </ul>
                  </dropdown-menu>
                </div>
                <div class="cv-item-body" @click="selectTemp(item, 'custom')">
                  <img src="@/assets/images/temp_docs/new/cv_tumbnail.svg" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <multipane-resizer></multipane-resizer>
        <!-- Cv preview -->
        <div
          :style="{ flexGrow: 1 }"
          class="cv-template-preview"
          v-if="selected_item"
        >
          <div class="preview-header">
            <h3>{{ selected_item.name }}</h3>
            <!-- <span class="date">Added:21/04/202</span>
            <span class="file-size">File size: 21kb</span> -->
          </div>
          <div class="preview-body">
            <img :src="selected_item.image" />
          </div>
        </div>
        <div v-else :style="{ flexGrow: 1 }" class="cv-template-preview">
          <div class="empty-widget">
            <img src="@/assets/admin-icon/cv-empty-icon.svg" />
            <h1>
              Download, Upload and Apply <span>CV Templates</span> to your
              consultants efficiently from this section.
            </h1>
            <p>Select one Template from the left to access more options</p>
          </div>
        </div>
        <!-- End Cv preview -->
      </multipane>
    </div>
    <!-- End -->

    <!-- Add and update cv -->
    <div class="cvs-form-widget" v-if="show_add_cv_modal">
      <div class="upload-cv-panel" v-if="section_type == 'all-cv'">
        <div class="widget-title">Add CV template</div>
        <div class="widget-body">
          <div class="input-group">
            <label>Template name</label>
            <input type="text" v-model="form.cv_name" class="input" />
          </div>
          <div class="input-file-group">
            <label>File</label>
            <div class="file-input-widget">
              <div class="file-input">
                <upload
                  :crop="false"
                  @onFileSelected="setCVFile"
                  caption="Add File"
                  remove_caption="Remove File"
                />
              </div>
              <div class="helper-text">
                The CV template to be uploaded, must respect the template
                structure of
                <a href="#" @click.prevent="download('default', 1)"
                  >the original copy</a
                >
                provided which is the
                <a
                  target="_brank"
                  href="https://jinja.palletsprojects.com/en/2.11.x/"
                  >Jinja template engine structure.</a
                >
              </div>
            </div>
          </div>
          <div class="replace-input-group">
            <input
              id="replace-cv-input"
              v-model="replace_exist_cv"
              type="checkbox"
            />
            <label for="replace-cv-input">Replace existing CV</label>
          </div>
          <div class="cvs-items" v-if="replace_exist_cv">
            <div class="cv-item" v-for="(item, index) in cvs_data" :key="index">
              <div class="cv-item-header">
                <label>{{ item.alias | validate }}</label>
                <input
                  type="radio"
                  name="cv"
                  v-model="form.cv_to_replace"
                  :value="item.id"
                  :id="`cv_${index}`"
                />
                <dropdown-menu>
                  <ul>
                    <li>
                      <a href @click.prevent="download('custom', item.name)"
                        >Download</a
                      >
                    </li>
                    <li>
                      <a href @click.prevent="selectCV(item)">Update</a>
                    </li>
                    <li>
                      <a href @click.prevent="appyTemp('custom', item.id)"
                        >Appy</a
                      >
                    </li>
                    <li>
                      <a href @click.prevent="removeTemp(item.id, item.name)"
                        >Remove</a
                      >
                    </li>
                  </ul>
                </dropdown-menu>
              </div>
              <div class="cv-item-body">
                <img src="@/assets/images/temp_docs/new/cv_tumbnail.svg" />
              </div>
            </div>
          </div>
        </div>
        <div class="widget-option">
          <consultfied-button
            class="btn-save"
            :loading="is_loading"
            @click="saveCV()"
            >Save</consultfied-button
          >
          <button class="cancel" @click="show_add_cv_modal = false">
            Cancel
          </button>
        </div>
      </div>
      <div class="upload-cv-panel" v-if="section_type == 'my-cv'">
        <div class="widget-title">Upload CV</div>
        <div class="widget-body">
          <div class="input-group">
            <label>File Name</label>
            <input type="text" v-model="cv_file_form.name" class="input" />
          </div>
          <div class="input-file-group">
            <label>File</label>
            <div class="file-input-widget">
              <div class="file-input">
                <upload
                  :crop="false"
                  @onFileSelected="setActualFile"
                  caption="Add File"
                  remove_caption="Remove File"
                />
              </div>
              <div class="helper-text"></div>
            </div>
          </div>
        </div>
        <div class="widget-option">
          <consultfied-button
            class="btn-save"
            :loading="is_loading"
            @click="saveFile()"
            >Save</consultfied-button
          >
          <button class="cancel" @click="show_add_cv_modal = false">
            Cancel
          </button>
        </div>
      </div>
    </div>

    <!-- Wizard -->
    <div class="wizard-overlay" v-if="show_wizard_modal">
      <div class="wizard-modal">
        <div class="wizard-header">
          <button
            class="btn-back"
            @click="prevWizard()"
            v-if="!wizard[0].active"
          >
            <img src="@/assets/icons/wizard-back.svg" />
          </button>
          <h3 class="wizard-title" v-if="wizard[0].active">
            Create, Upload and Share
          </h3>
          <h3 class="wizard-title" v-if="wizard[1].active">
            Customisable and Downloadable
          </h3>
          <h3 class="wizard-title" v-if="wizard[2].active">
            Let us do it for you
          </h3>
          <button class="btn-close" @click="closeWizardModal()">&times;</button>
        </div>
        <div class="wizard-body">
          <div class="screen" v-if="wizard[0].active">
            <img src="@/assets/cvs_wizard/screen_1.svg" />
            <p>
              <b>Create, Upload and Share</b> your consultants CVs
              professionally than before…
            </p>
          </div>
          <div class="screen" v-if="wizard[1].active">
            <img src="@/assets/cvs_wizard/screen_2.svg" />
            <p>
              <b>Download and customize your own template!</b>
            </p>
          </div>
          <div class="screen" v-if="wizard[2].active">
            <img src="@/assets/cvs_wizard/screen_3.svg" />
            <p>
              Let us
              <b>Build your CV for you</b>, the way you want it.
            </p>
          </div>
          <div class="dots">
            <div
              v-for="(item, index) in wizard"
              :key="index"
              class="dot"
              :class="{ active: item.active }"
            ></div>
          </div>
        </div>
        <div class="wizard-option">
          <button
            class="btn-next"
            @click="nextWizard()"
            v-if="!wizard[2].active"
          >
            Next
          </button>
          <button
            class="btn-next"
            @click="nextWizard()"
            v-if="wizard[2].active"
          >
            Get Started
          </button>
          <a
            href
            class="how-labele"
            v-if="!wizard[0].active"
            @click.prevent="prevWizard()"
            >Back</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appDialog from "@/components/Dialog/AppDialog.vue";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import { mapGetters } from "vuex";
import { eventBus } from "@/main";
import HelpToolTip from "@/components/helper/HelpToolTip.vue";
import upload from "@/components/Partials/Uploader.vue";

export default {
  name: "cvs",
  components: {
    appDialog,
    consultfiedButton,
    HelpToolTip,
    upload,
  },
  props: {},
  data: () => {
    return {
      show_add_cv_modal: false,
      replace_exist_cv: false,
      form: {
        id: null,
        cv_name: "",
        cv_file: null,
        cv_file_url: "",
        cv_to_replace: 0,
      },
      apply_form: {
        apply_all: false,
        type: "",
        temp_name: "",
        members: [],
      },
      cv_file_form: {
        id: null,
        name: "",
        path: "/",
        file: null,
        file_url: "",
      },
      show_cv_apply_cv_modal: false,
      is_loading: false,
      cvs_data: [],
      appy_cv_member_loading: false,
      added_member_list: [],
      company_member_list: [],
      search_consultant_member: "",
      wizard_active_screen: -1,
      wizard: [{ active: false }, { active: false }, { active: false }],
      show_wizard_modal: false,
      section_type: "all-cv",
      create_folder_widget: false,
      folder_form: {
        id: null,
        name: "",
        path: "/",
      },
      cv_file_manager: [],
      selected_item: null,
      default_template: [
        { name: "Basic", n: 1 },
        { name: "Vanilla", n: 2 },
        { name: "Classic", n: 3 },
        { name: "Fancy", n: 4 },
        { name: "School", n: 5 },
      ],
    };
  },
  mounted() {
    let vm = this;
    vm.getCvsData();
    vm.nextWizard();
    let path = vm.cv_file_form.path;
    vm.getCVFileManager(path);
    if (vm.$localStorage.get(vm.$getLoggedUser().email + "_crm_cv_wizard")) {
      vm.closeWizardModal();
    }
  },
  computed: {},
  watch: {
    search_consultant_member: function (query) {
      this.searchPeople(query);
    },
    replace_exist_cv: function (val) {
      if (val == false) {
        this.form.cv_to_replace = 0;
      }
    },
  },
  methods: {
    selectTemp(item, type, number = null) {
      let vm = this;
      vm.selected_item = item;
      if (type == "custom") {
        eventBus.$set(
          vm.selected_item,
          "image",
          require("@/assets/images/temp_docs/new/cv_tumbnail.svg")
        );
        eventBus.$set(vm.selected_item, "name", item.alias);
      } else if (type == "default") {
        eventBus.$set(
          vm.selected_item,
          "image",
          require("@/assets/images/temp_docs/new/" + number + ".svg")
        );
      }
    },
    fileExt(file_name) {
      return file_name.split(".").pop();
    },
    enterDir(item) {
      let vm = this;
      let path = (vm.cv_file_form.path = vm.cv_file_form.path + item + "/");
      vm.getCVFileManager(path);
    },
    isFile(file_name) {
      let vm = this;
      return file_name.slice(
        (Math.max(0, file_name.lastIndexOf(".")) || Infinity) + 1
      )
        ? true
        : false;
    },
    DownloadCVFile(path, file_name) {
      let vm = this;
      vm.$store
        .dispatch("COMPANY_DOWNLOAD_CV_FILE", { path: path, name: file_name })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file_name); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error));
    },
    DirBack() {
      let vm = this;
      const path = vm.cv_file_form.path.split("/");
      if (path.length > 1) {
        let index = path.length - 2;
        path.splice(index, 1);
        var path_string = path.join("/");
        vm.cv_file_form.path = path_string;
        vm.getCVFileManager(vm.cv_file_form.path);
      } else {
        var path_string = "/";
        vm.cv_file_form.path = path_string;
        vm.getCVFileManager(vm.cv_file_form.path);
      }
    },
    deleteFileOrFolder(path, type) {
      let vm = this;
      vm.$store
        .dispatch("COMPANY_CV_DELETE_FILE_FOLDER", { path: path, type: type })
        .then((responce) => {
          let path = vm.cv_file_form.path;
          vm.getCVFileManager(path);
          vm.$notify({
            group: "status",
            title: "Message",
            text: type + " was deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Something wrong",
            text: "Error while deleting " + type + ", Please try again.",
            type: "warn",
            duration: 3000,
          });
        });
    },
    getCVFileManager(path) {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("COMPANY_GET_MY_CV", { path: path })
        .then((responce) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.cv_file_manager = responce.data;
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.log(error);
        });
    },
    createFolder() {
      let vm = this;
      vm.folder_form.path = vm.cv_file_form.path;
      if (!vm.folder_form.id) {
        vm.$store
          .dispatch("COMPANY_ADD_NEW_FOLDER", vm.folder_form)
          .then((responce) => {
            vm.create_folder_widget = false;
            let path = vm.cv_file_form.path;
            vm.getCVFileManager(path);
            vm.$notify({
              group: "status",
              title: "Message",
              text: "New folder was added",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while adding new folder, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      } else {
        vm.$store
          .dispatch("COMPANY_UPDATE_FOLDER", vm.folder_form)
          .then((responce) => {
            vm.create_folder_widget = false;
            let path = vm.cv_file_form.path;
            vm.getCVFileManager(path);
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Folder was updated",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while updating folder, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    saveFile() {
      let vm = this;
      let form_data = new FormData();
      form_data.append("id", vm.cv_file_form.id);
      form_data.append("name", vm.cv_file_form.name);
      form_data.append("path", vm.cv_file_form.path);
      if (vm.cv_file_form.file) {
        form_data.append(
          "file",
          vm.cv_file_form.file,
          vm.cv_file_form.file.name
        );
      }
      if (!vm.cv_file_form.id) {
        vm.is_loading = true;
        vm.$store
          .dispatch("COMPANY_ADD_NEW_CV_FILE", form_data)
          .then((responce) => {
            vm.is_loading = false;
            vm.show_add_cv_modal = false;
            let path = vm.cv_file_form.path;
            vm.getCVFileManager(path);
            vm.$notify({
              group: "status",
              title: "Message",
              text: "New cv file was added",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.is_loading = false;
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while adding cv, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      } else {
        vm.is_loading = true;
        vm.$store
          .dispatch("COMPANY_UPDATE_CV_FILE", form_data)
          .then((responce) => {
            vm.is_loading = false;
            vm.show_add_cv_modal = false;
            let path = vm.cv_file_form.path;
            vm.getCVFileManager(path);
            vm.$notify({
              group: "status",
              title: "Message",
              text: "New cv file was updated",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.is_loading = false;
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while updating cv, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    setActualFile(file) {
      let vm = this;
      if (file) {
        vm.cv_file_form.file = file;
      }
    },
    switchSection(section) {
      let vm = this;
      vm.section_type = section;
    },
    closeWizardModal() {
      let vm = this;
      vm.show_wizard_modal = false;
      vm.$localStorage.set(vm.$getLoggedUser().email + "_crm_cv_wizard", true);
    },
    prevWizard() {
      let vm = this;
      vm.wizard_active_screen -= 1;
      vm.wizard.forEach((item) => {
        item.active = false;
      });
      if (vm.wizard_active_screen > -1) {
        vm.wizard[vm.wizard_active_screen].active = true;
      }
    },
    nextWizard() {
      let vm = this;
      vm.wizard_active_screen += 1;
      vm.wizard.forEach((item) => {
        item.active = false;
      });
      if (vm.wizard_active_screen < vm.wizard.length) {
        vm.wizard[vm.wizard_active_screen].active = true;
      } else {
        vm.closeWizardModal();
        vm.wizard_active_screen = -1;
      }
    },
    selectCV(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.cv_name = item.alias;
      vm.show_add_cv_modal = true;
    },
    removeTemp(id, name) {
      let vm = this;
      vm.$store
        .dispatch("COMPANY_REMOVE_CV", { id: id, temp_name: name })
        .then((response) => {
          vm.getCvsData();
        })
        .catch((error) => console.log(error));
    },
    download(type, file_name) {
      let vm = this;
      let name = "";
      if (type == "default") {
        name = "cvs/template_" + file_name + ".docx";
      } else {
        name = file_name;
      }
      vm.$store
        .dispatch("COMPANY_DOWNLOAD_CV", { name: name })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file_name + ".docx"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error));
    },
    addMate(member) {
      let vm = this;
      let obj = {
        id: member.id,
        names: member.first_name + " " + member.last_name,
        picture: member.profile_picture,
        closable: true,
      };
      vm.added_member_list.push(obj);
      vm.search_consultant_member = "";
    },
    removeMate(id, i) {
      let vm = this;
      vm.added_member_list.splice(i, 1);
    },
    searchPeople(query) {
      let vm = this;
      vm.$store
        .dispatch("SEARCH_FOR_COMPANY_MEMBERS", { query: query })
        .then((responce) => {
          vm.company_member_list = responce.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveApplieCv() {
      let vm = this;
      vm.appy_cv_member_loading = true;
      vm.apply_form.members = vm.added_member_list.map((item) => item.id);
      vm.$store
        .dispatch("COMPANY_APPLY_CV", vm.apply_form)
        .then((responce) => {
          vm.appy_cv_member_loading = false;
          vm.show_cv_apply_cv_modal = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Now cv was applied successfully",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.appy_cv_member_loading = false;
          vm.$notify({
            group: "status",
            title: "Something wrong",
            text: "Error while appliying cv, Please try again.",
            type: "warn",
            duration: 3000,
          });
          console.log(error);
        });
    },
    appyTemp(type, temp_name) {
      let vm = this;
      vm.apply_form.type = type;
      if (type == "default") {
        vm.apply_form.temp_name = `cvs/template_${temp_name}.docx`;
      } else {
        vm.apply_form.temp_name = temp_name;
      }
      // May this option will be updated soon
      // vm.show_cv_apply_cv_modal = true;
      vm.$store
        .dispatch("COMPANY_APPLY_CV", vm.apply_form)
        .then((responce) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Now cv was applied successfully",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Something wrong",
            text: "Error while appliying cv, Please try again.",
            type: "warn",
            duration: 3000,
          });
        });
    },
    saveCV() {
      let vm = this;
      let form_data = new FormData();
      form_data.append("cv_name", vm.form.cv_name);
      form_data.append("cv_to_replace", vm.form.cv_to_replace);
      form_data.append("id", vm.form.id);
      if (vm.form.cv_file) {
        form_data.append("cv_file", vm.form.cv_file, vm.form.cv_file.name);
      }
      if (!vm.form.id) {
        vm.is_loading = true;
        vm.$store
          .dispatch("COMPANY_ADD_NEW_CV", form_data)
          .then((responce) => {
            vm.is_loading = false;
            vm.show_add_cv_modal = false;
            vm.getCvsData();
            vm.$notify({
              group: "status",
              title: "Message",
              text: "New cv was added",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.is_loading = false;
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while adding cv, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      } else {
        vm.is_loading = true;
        vm.$store
          .dispatch("COMPANY_UPDATE_CV", form_data)
          .then((responce) => {
            vm.is_loading = false;
            vm.show_add_cv_modal = false;
            vm.getCvsData();
            vm.$notify({
              group: "status",
              title: "Message",
              text: "New cv was updated",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.is_loading = false;
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while updating cv, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    setCVFile(file) {
      let vm = this;
      if (file) {
        vm.form.cv_file = file;
      }
    },
    getCvsData() {
      let vm = this;
      vm.$store
        .dispatch("GET_USER_COMPANY_CV")
        .then((responce) => {
          vm.cvs_data = responce.data;
        })
        .catch((error) => {
          console.error({ error });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.cvs-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  .company-profile-container {
    padding: 1px;
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    @media (min-width: 300px) and (max-width: 630px) {
      padding: 15px;
    }
    .custom-resizer {
      height: 100%;
    }

    // List of templates
    .company-profile-body {
      border-radius: 5px;
      margin-bottom: 20px;
      padding: 15px 15px;
      background: #fff;
      height: 100%;
      display: flex;
      flex-direction: column;
      min-width: 400px;
      width: 100%;
      .search-widget {
        background: #fff;
        display: grid;
        grid-column-gap: 20px;
        margin-bottom: 5px;
        height: 45px;
        .search-widget {
          border: 1px solid #ccc;
          height: 45px;
          display: flex;
          align-items: center;
          padding: 0px 10px;
          border-radius: 5px;
          img {
            width: 25px;
            height: 25px;
          }
          input {
            height: 42px;
            width: 100%;
            outline: none;
            border: none;
          }
        }
      }
      .cvs-item-header {
        display: flex;
        justify-content: space-between;
        padding: 6px 0px;
        height: 33px;
        .title {
          font-size: 20px !important;
          @media (min-width: 300px) and (max-width: 630px) {
            font-size: 16px !important;
            font-weight: 800;
          }
        }
        .options {
          display: flex;
          align-items: center;
          .add-btn {
            color: #1885ad;
            display: flex;
            font-style: italic;
            outline: none;
          }
        }
      }
      .cvs-body {
        height: calc(100% - 120px);
        overflow-y: auto;
        .cvs-items {
          margin-top: 10px;
          display: grid;
          grid-template-columns: 31.333% 31.333% 31.333%;
          grid-gap: 10px;
          justify-content: space-between;
          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 48% 48%;
          }
          .cv-item {
            background: #fff;
            border-radius: 5px;
            border: 1px solid #ddd;
            .cv-item-header {
              display: flex;
              justify-content: space-between;
              padding: 0px 5px;
              align-items: center;
              border-bottom: 1px solid #ddd;
              height: 40px;
              label {
                width: 99%;
                padding-top: 9px;
                font-size: 15px;
                align-items: center;
                display: flex;
                padding-left: 8px;
              }
            }
            .cv-item-body {
              padding: 10px 0px;
              img {
                width: 100%;
                height: 150px;
                object-fit: contain;
              }
            }
          }
        }
      }
    }
    // Templates preview
    .cv-template-preview {
      width: 400px;
      height: 100%;
      min-width: 400px;
      max-width: 700px;
      background: transparent;
      border-radius: 5px;
      .empty-widget {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0px 50px;
        padding-top: 60px;
        img {
          width: 150px;
        }
        h1 {
          font-size: 18px;
          color: rgb(58, 57, 57);
          text-align: center;
          margin-top: 30px;
          span {
            font-size: 18px;
            color: rgb(0, 0, 0);
            font-weight: 800;
          }
        }
        p {
          font-size: 13px;
          color: rgb(58, 57, 57);
          margin-top: 40px;
          text-align: center;
        }
      }
      .preview-header {
        display: flex;
        flex-direction: column;
        padding: 15px 10px;
        h3 {
          margin: 0px;
          font-size: 18px;
          margin-bottom: 3px;
        }
        span {
          font-size: 12px;
        }
      }
      .preview-body {
        width: 100%;
        height: calc(100% - 80px);
        img {
          width: 100%;
          object-fit: contain;
          height: 100%;
          background: #031019;
        }
      }
    }
  }

  .cvs-form-widget {
    position: fixed;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    background: rgba(0, 0, 0, 0.8);
    z-index: 99999;
    display: flex;
    justify-content: center;
    padding: 85px;
    overflow-y: auto;
    @media (min-width: 300px) and (max-width: 630px) {
      padding: 85px 10px;
    }
    .upload-cv-panel {
      background: #fff;
      width: 600px;
      min-height: 100px;
      border-radius: 5px;
      display: inline-table;
      padding: 40px;
      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
        padding: 15px;
      }
      .widget-title {
        font-size: 18px;
      }
      .widget-body {
        margin-top: 20px;
        .input-group {
          display: flex;
          flex-direction: column;
          margin-bottom: 10px;
          .input {
            border: 1px solid #ddd;
            height: 45px;
            border-radius: 5px;
            outline: none;
            padding: 0px 15px;
          }
        }
        .input-file-group {
          .file-input-widget {
            display: grid;
            grid-template-columns: 200px calc(98% - 200px);
            grid-column-gap: 20px;
            @media (min-width: 300px) and (max-width: 630px) {
              grid-template-columns: 100%;
            }
            .helper-text {
              padding-left: 10%;
              @media (min-width: 300px) and (max-width: 630px) {
                grid-template-columns: 100%;
                padding-left: 0px;
              }
            }
          }
        }
        .replace-input-group {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 20px;
          label {
            margin-left: 5px;
            margin-top: 4px;
          }
        }
        .cvs-items {
          margin-top: 10px;
          display: grid;
          grid-template-columns: 31.3333% 31.33333% 31.3333%;
          grid-gap: 20px;
          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 48% 48%;
          }
          .cv-item {
            background: #fff;
            border-radius: 5px;
            border: 1px solid #ddd;
            .cv-item-header {
              display: flex;
              justify-content: space-between;
              padding: 0px 5px;
              align-items: center;
              border-bottom: 1px solid #ddd;
              label {
                width: 99%;
                padding-top: 9px;
                font-size: 15px;
                align-items: center;
                display: flex;
                padding-left: 8px;
              }
            }
            .cv-item-body {
              padding: 10px 0px;
              img {
                width: 100%;
              }
            }
          }
        }
      }
      .widget-option {
        margin-top: 30px;
        display: flex;
        align-items: center;
        .btn-cancel {
          color: #1ba5a4;
          cursor: pointer;
          font-weight: normal;
          height: 40px;
          padding: 3px 20px;
          font-size: 14px;
          width: 100px;
        }
        .btn-save {
          background: #1ba5a4;
          color: #fff;
          font-size: 14px;
          font-weight: normal;
          cursor: pointer;
          border-radius: 5px;
          height: 40px;
          width: 100px;
          padding: 3px 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 20px;
          &:disabled {
            background: #8d8d8d;
            opacity: 0.3;
          }
        }
      }
    }
  }
  .apply-cv-overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 9999999;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    padding-top: 100px;
    .apply-cv-modal {
      width: 500px;
      display: inline-table;
      background: #fff;
      border-radius: 5px;
      .apply-cv-header {
        padding: 15px 20px;
        h4 {
          font-size: 17px;
        }
      }
      .apply-cv-body {
        padding: 15px 20px;
        .input-group {
          display: flex;
          flex-direction: column;
          position: relative;
          .check-option {
            display: flex;
            align-items: center;
            input {
              margin-right: 10px;
            }
          }
          .search-container {
            border: 1px solid #ccc;
            height: 45px;
            display: flex;
            align-items: center;
            padding: 0px 10px;
            border-radius: 5px;
            img {
              width: 25px;
              height: 25px;
            }
            input {
              height: 45px;
              width: 100%;
              padding-left: 15px;
              outline: none;
            }
          }
          .search_dropdown__body {
            position: absolute;
            top: 68px;
            width: 100%;
            background: #fff;
            z-index: 999;
            box-shadow: 0px 4px 7px rgb(49, 49, 49);
            height: 194px;
            overflow-y: auto;
            border-radius: 5px;
            .dropdown__item {
              display: flex;
              align-items: center;
              border-bottom: 1px solid #e8e8e8;
              padding: 20px 10px;
              cursor: pointer;
              &:hover {
                background: #e8e8e8;
              }
              img {
                height: 30px;
                width: 30px;
                object-fit: cover;
                margin-right: 15px;
                border-radius: 50%;
              }
              .text {
                span {
                  font-size: 15px;
                }
              }
            }
          }
        }
        .pitch-body {
          .pitch-body-title {
            font-size: 12px;
            color: #031019;
          }
          .pitch-fieldset {
            border-radius: 5px;
            padding: 4px 0px;
            .collaboraters-widget {
              padding: 10px 0px;
              display: flex;
              flex-wrap: wrap;
              .item {
                background: #1ba5a4 0% 0% no-repeat padding-box;
                border-radius: 20px;
                display: flex;
                align-items: center;
                padding: 4px 4px;
                margin-right: 8px;
                margin-bottom: 8px;
                position: relative;
                .profile-img {
                  width: 26px;
                  height: 26px;
                  border-radius: 50%;
                  margin-right: 5px;
                }
                .name {
                  color: #fff;
                  margin-right: 10px;
                }
                .remove-pitch-btn {
                  background: crimson;
                  border-radius: 50%;
                  height: 20px;
                  width: 20px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: absolute;
                  top: -11px;
                  right: -7px;
                }
              }
            }
          }
          .sectected-pitch-count {
            font-size: 14px;
            color: #6e6e6e;
            margin-top: 10px;
            display: block;
          }
        }
      }
    }
    .apply-cv-option {
      padding: 15px 20px;
      display: flex;
      .btn-save {
        width: 100px;
        height: 45px;
        background: #1890a9 0% 0% no-repeat padding-box;
        border-radius: 4px;
        color: #fff;
        outline: none;
        margin-right: 20px;
        display: center;
        justify-content: center;
      }
      .btn-back {
        height: 45px;
        border-radius: 4px;
        color: #1890a9;
        outline: none;
      }
    }
  }
  // wizard
  .wizard-overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 9999999;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    padding-top: 100px;
    overflow-y: auto;
    @media (min-width: 300px) and (max-width: 630px) {
      padding-top: 0px;
    }
    .wizard-modal {
      width: 500px;
      display: inline-table;
      background: #fff;
      border-radius: 5px;
      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
        display: unset;
      }
      .wizard-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 70px;
        background: #1ba5a4;
        padding: 0px 20px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        .btn-back {
          font-size: 15px;
          font-weight: 800;
          color: #fff;
          outline: none;
          img {
            width: 11px;
            margin-top: 8px;
          }
        }
        .wizard-title {
          color: #fff;
        }
        .btn-close {
          font-size: 37px;
          font-weight: 800;
          color: #ddd;
        }
      }
      .wizard-body {
        padding: 25px 80px;
        .screen {
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            width: 180px;
            height: 200px;
            object-fit: contain;
          }
          p {
            text-align: center;
            margin-top: 25px;
          }
        }
        .dots {
          display: flex;
          align-items: center;
          justify-content: center;
          .dot {
            height: 6px;
            width: 6px;
            background: #707070;
            margin-right: 10px;
            border-radius: 50%;
            transition: 1s ease-in-out;
            &.active {
              border-radius: 2px;
              width: 20px;
              transition: 1s ease-in-out;
            }
          }
        }
      }
      .wizard-option {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding-bottom: 15px;
        .btn-next {
          width: 163px;
          height: 45px;
          background: #1ba5a4;
          box-shadow: 0px 3px 6px #00000029;
          border-radius: 5px;
          color: #fff;
          margin-bottom: 13px;
          outline: none;
        }
        .how-labele {
          color: #2090ba;
          text-transform: none;
          text-decoration: none;
        }
      }
    }
  }
}
</style>